import { Component, OnInit } from '@angular/core';
import { ModalitesService } from 'src/app/core/modalites.service';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { FiltreService } from 'src/app/shared/filtre.service';
import { FilteredSelectInputKeypadComponent } from './filtered-select-input-keypad.component';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

/**
 * Composant pour gérer une liste de modalité affectée à une variable.
 * Optimisé pour les enquêtes décisions. On utilise pas HTML5 ici.
 */
@Component({
  selector: 'bis-filtered-select-sans-consultation-input-keypad',
  templateUrl: './filtered-select-sans-consultation-input-keypad.component.html',
  styleUrls: ['../../input/input.component.css']
})
export class FilteredSelectSansConsultationInputKeypadComponent extends FilteredSelectInputKeypadComponent implements OnInit {

  constructor(
      protected modalitesService: ModalitesService,
      protected formulaireService: FormulaireService,
      protected libelleService: LibellesService,
      protected filtreService: FiltreService,
      protected modeRendu: ModeRenduService
    ) {
      super(modalitesService, formulaireService, libelleService, filtreService, modeRendu);
    }

  ngOnInit() {
    super.ngOnInit();
  }

}
